import amplitudeAnalytics, {hostType} from '../../utils/amplitudeAnalytics';
import {getQueryParam} from "../../utils/getQueryParamValue";
import {COUNTRY} from "../../../config";

document.addEventListener('DOMContentLoaded', function() {
  if (COUNTRY === 'tg') {
    trackBlockScreen();
  }
});

const trackBlockScreen = () => {
  const userTgId = getQueryParam('userId') ?? getQueryParam('user')?.id;

  void amplitudeAnalytics.track('Authorization_BlockScreen_TG', {
    host_type: hostType(),
    ...(userTgId && {user_tg_id: userTgId}),
  });
}
